import { ApplicationWithDetails } from '../../../types';
import { SpurtDescription } from './SpurtDescription';
import { SpurtInstructions } from './SpurtInstructions/SpurtInstructions';
import { spurtPlans } from './SpurtPlans';

export const Spurt: ApplicationWithDetails = {
	id: `11EDF0CB38BDE6B8BE4756D61637848D`,
	name: `Spurt`,
	description: `Управляй всем бизнесом из Telegram.\nПовышай личную продуктивность и эффективность команды.`,
	descriptionCard: `Управляй всем бизнесом из Telegram.`,
	descriptionHTML: SpurtDescription,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/spurt/logo-1`,
	sliders: [`https://cdn.dodostatic.net/static/marketplace/spurt/slider-new-1`],
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/spurt/logo-bgr`,
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	webSiteUrl: `https://spurt.dev/`,
	supportUrl: null,
	redirectUrl: ``,
	contactEmail: `Телеграм-чат`,
	supportEmail: `https://t.me/+ouBXJgE4f1IzOTUy`,
	type: `Бот`,
	categories: [`Отчеты`, `Уведомления`, `Мониторинг производства`],
	countries: [`Все`],
	languages: [`Русский`, `English`],
	price: `Бесплатно`,
	version: `1.0`,
	developer: `Spurt.dev`,
	plans: spurtPlans,
	instructions: SpurtInstructions,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: true,
	versionHistory: `https://doc.clickup.com/2699605/d/h/2jcan-21464/9934edd7f480e01/2jcan-15344`,
	goToApp: true,
};
